import i18n from '@/locales/index'
export default [
  {
    type: 'select',
    placeholder: '',
    filed: 'days',
    default: 1,
    options: [
      {
        code: 1,
        name: `1${i18n.t('Device.unitDay')}`
      },
      {
        code: 7,
        name: `7${i18n.t('Device.unitDay')}`
      },
      {
        code: 30,
        name: `30${i18n.t('Device.unitDay')}`
      }
    ]
  }
]
